import useNavigation from 'core/hooks/useNavigation'
import { useSettings } from 'core/hooks/useSettings'
import { useEffect } from 'react'

const ApplyMobileView = () => {
  const { search } = useNavigation()
  const {
    set,
    data: { inAppView }
  } = useSettings()

  useEffect(() => {
    const isAppRegex = new RegExp('[?&]' + 'inAppView' + '=([^&]+).*$')
    const hasInAppUrlSearch = isAppRegex.test(search)
    if (hasInAppUrlSearch && !inAppView) set('inAppView', true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (inAppView) document.body.classList.add('in-app-view')
  return null
}

export default ApplyMobileView
